module.exports = __webpack_public_path__ + "img/plane.210344b7.png";